import FormStyleEditorSessionDetailsPanel from './FormStyleEditorSessionDetailsPanel';

export default FormStyleEditorSessionDetailsPanel;
